export default {
      id: "ic_chance_games_play-again-usage",
      viewBox: "0 0 18 13",
      url: "/" + "images/icons.3.109.2.svg#ic_chance_games_play-again-usage",
      toString: function () {
        return this.url;
      }
    }